<!-- No backdrop behind the full-page co-pilot: the navigation stays usable. -->
<mat-sidenav-container
  class="sidenav-container"
  [class.copilot-expanded]="copilotCovers()"
  [class.copilot-shrinking]="copilotCovers() && !copilot.expanded()"
  autosize
  [hasBackdrop]="copilotCovers() ? false : null"
>
  <mat-sidenav
    class="sidenav"
    [ngClass]="{'is-open': open()}"
    [mode]="drawerMode()"
    [fixedInViewport]="isMobile()"
    [opened]="isMobile() ? open() : true"
    (closed)="_sidenavService.close()"
  >
    <div class="sidenav-items">
      <a [routerLink]="['/']" class="logo-link">
        @if (logoPath(); as logoPath) {
          <img [src]="logoPath" width="30" alt="Main app logo" class="logo" />
        }
      </a>

      <button
        mat-mini-fab
        class="toggle-button"
        [ngClass]="{'is-active': open()}"
        (click)="toggleSidenav()"
      >
        <mat-icon fontSet="material-symbols-rounded">chevron_left</mat-icon>
      </button>

      <mat-nav-list class="sidenav-list">
        @if (!isMobile()) {
          @if (((locations$ | async)?.length || 0) > 0) {
            @for (item of items; track item.section) {
              @if (item.enabled) {
                <a
                  mat-list-item
                  class="sidenav-item"
                  [routerLink]="['/l', 'current', item.section]"
                  [class.is-active]="activeSection() === item.section"
                >
                  <mat-icon matListItemIcon fontSet="material-symbols-rounded">{{
                    item.icon
                  }}</mat-icon>
                  <span matListItemTitle class="sidenav-title">{{
                    item.labelKey | translate
                  }}</span>
                </a>
              } @else {
                <span
                  class="disabled-item-wrapper"
                  [matTooltip]="'comingSoonTooltip' | translate"
                  matTooltipPosition="right"
                >
                  <a
                    mat-list-item
                    class="sidenav-item is-disabled"
                    aria-disabled="true"
                    tabindex="-1"
                  >
                    <mat-icon matListItemIcon fontSet="material-symbols-rounded">{{
                      item.icon
                    }}</mat-icon>
                    <span matListItemTitle class="sidenav-title">{{
                      item.labelKey | translate
                    }}</span>
                    <span matListItemMeta class="soon-chip">{{ 'comingSoon' | translate }}</span>
                  </a>
                </span>
              }
            }
          }
        }

        <div class="bottom-actions">
          @if ((locations$ | async) && ((locations$ | async)?.length || 0) === 0) {
            <a mat-list-item class="sidenav-item add-business" [routerLink]="['/add-business']">
              <mat-icon matListItemIcon fontSet="material-symbols-rounded">add_business</mat-icon>
              <div class="sidenav-title">{{ 'business' | translate }}</div>
            </a>
          } @else {
            @if (currentLocation(); as location) {
              <button
                mat-list-item
                class="sidenav-item"
                [class.is-active]="activeSection() === 'data'"
                (click)="openPicker()"
              >
                @if (showLogo()) {
                  <img
                    matListItemIcon
                    class="location-logo"
                    [src]="location.logo!.url"
                    width="20"
                    alt=""
                    (error)="onLogoError()"
                  />
                } @else {
                  <mat-icon matListItemIcon fontSet="material-symbols-rounded">storefront</mat-icon>
                }
                <div class="sidenav-title">{{ location.name }}</div>
              </button>
            }
          }

          <a
            mat-list-item
            class="sidenav-item settings"
            [routerLink]="['/settings']"
            routerLinkActive="is-active"
            [routerLinkActiveOptions]="{exact: true}"
          >
            @if (authService.isPasswordless()) {
              <mat-icon
                matListItemIcon
                matListIcon
                fontSet="material-symbols-rounded"
                matBadge="1"
                matBadgeSize="small"
                matBadgeOverlap="true"
                matBadgeColor="warn"
                aria-hidden="false"
                [matBadgeDescription]="'secureYourAccount' | translate"
                >settings</mat-icon
              >
            } @else {
              <mat-icon
                matListItemIcon
                matListIcon
                fontSet="material-symbols-rounded"
                aria-hidden="true"
                >settings</mat-icon
              >
            }
            <div matListItemTitle class="sidenav-title">{{ 'settings' | translate }}</div>
          </a>
        </div>
      </mat-nav-list>
    </div>
  </mat-sidenav>

  <!-- AI co-pilot: a second, end-side drawer in the same container, so on
       wide screens it pushes the page aside instead of covering it. Full
       page, it covers the page instead (which stays as it was). -->
  <mat-sidenav
    class="copilot-sidenav"
    [class.expanded]="copilot.expanded()"
    position="end"
    [mode]="copilotCovers() ? 'over' : copilotMode()"
    [fixedInViewport]="isMobile()"
    [opened]="copilot.isOpen()"
    (openedChange)="$event || copilotClosed()"
    (transitionend)="copilotResized($event)"
    (transitioncancel)="copilotResized($event)"
    [attr.aria-label]="'copilotTitle' | translate"
  >
    <ng-content select="[copilot]"></ng-content>
  </mat-sidenav>

  <mat-sidenav-content
    class="sidenav-content"
    [ngClass]="{'no-mobile-nav': ((locations$ | async)?.length || 0) === 0}"
  >
    <ng-content></ng-content>
  </mat-sidenav-content>
</mat-sidenav-container>
